import { MessagingPlatform, UserCommunication } from '@this+that/models';

import { CHAT_PLATFORMS } from '../../hooks/DoBox/constants';

/**
 * Sorts communications by date with platform-aware ordering:
 * - Chat platforms (Slack, Teams, Google Chat): oldest first (ascending) for conversation flow
 * - Email platforms (Gmail, Outlook): newest first (descending)
 *
 * Returns a new sorted array without mutating the original.
 */
export function sortCommunicationsByDate(
  communications: Partial<UserCommunication>[],
): Partial<UserCommunication>[] {
  return [...communications].sort((a, b) => {
    const dateA = new Date(a.createdAt || 0).getTime();
    const dateB = new Date(b.createdAt || 0).getTime();

    const isChat = CHAT_PLATFORMS.has(a.platform as MessagingPlatform);
    return isChat ? dateA - dateB : dateB - dateA;
  });
}
